// removed by extract-text-webpack-plugin
module.exports = {"imageContainer":"LandingStronghold_imageContainer--3XjDX"};


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/components/LandingStronghold/LandingStronghold.scss
// module id = 2299
// module chunks = 11